<template>
  <div>
    <v-container fluid>
      <v-container class="container-custom">
        <Breadcrumbs :title="discountCoupon?.name">
          <v-menu offset-y v-if="canUpdate || canAssign">
            <template v-slot:activator="{ on: menu }">
              <v-btn text color="primary" v-on="{ ...menu }">
                <v-icon>mdi-dots-vertical</v-icon>
                {{ $t('modules.benefits.details.breadcrumbs.actions') }}
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item v-if="canUpdate" @click="$router.push(`/coupons/update/${$route.params.id}`)">
                <v-list-item-title>
                  <v-icon>mdi-pencil</v-icon>
                  {{ $t('actions.edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canAssign && discountCoupon?.status" @click="deleteDiscountPopUp($route.params.id)">
                <v-list-item-title>
                  <v-icon>mdi-delete</v-icon>
                  {{ $t('actions.disable') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </Breadcrumbs>
      </v-container>
      <v-container class="superTable container-custom pt-0 pb-8">
        <v-row justify="start" align-content="stretch">
          <v-col cols="12 pt-0">
            <v-sheet color="#f5f6f9" class="px-3 BenefitsDetails-info-sheet">
              <v-row>
                <v-col cols="8" class="py-0 my-3" style="border-right: 1px solid #cecece !important;">
                  <table class="BenefisDetails-info-table" height="100%" width="100%">
                    <thead>
                      <tr>
                        <th class="primary--text text-center">{{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.maxUsagesPerUser') }}</th>
                        <th class="primary--text text-center">{{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.discount') }}</th>
                        <th class="primary--text text-center">{{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.minPayment') }}</th>
                        <th class="primary--text text-center">{{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.maxDiscount') }}</th>
                        <th class="primary--text text-center">{{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.productType') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">{{ resume.maxUsagesPerUser }}</td>
                        <td class="text-center">{{ resume.discount }}</td>
                        <td class="text-center">{{ resume.minPayment | formatCurrency }}</td>
                        <td class="text-center">{{ resume.maxDiscount | formatCurrency }}</td>
                        <td class="text-center">{{ resume.productType }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
                <v-col cols="4">
                  <table class="BenefisDetails-info-table" height="100%" width="100%">
                    <thead>
                      <tr>
                        <th class="primary--text text-center">
                          {{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.dateFrom')  }}
                        </th>
                        <th class="primary--text text-center">
                          {{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.dateTo')  }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="with-line">
                        <td class="text-center">{{ resume.dateFrom }}</td>
                        <td class="text-center">{{ resume.dateTo || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col cols="3" align-content="stretch">
            <v-sheet color="#f5f6f9" class="px-3 BenefitsDetails-info-sheet" align="center" style="height:100%">
              <v-row justify="center" align="center">
                <v-col cols="6" justify="center" align="start">
                  <strong class="primary--text">
                    {{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.BenefitsStudents') }}
                  </strong><br>
                </v-col>
                <v-col cols="6" justify="center" align="center">
                  <h1>{{ resume.totalStudents }}</h1>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col cols="3" align-content="stretch">
            <v-sheet color="#f5f6f9" class="px-3 BenefitsDetails-info-sheet" align="center" style="height:100%">
              <v-row justify="center" align="center">
                <v-col cols="6" justify="center" align="start">
                  <strong class="primary--text">
                    {{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.totalUses') }}
                  </strong><br>
                </v-col>
                <v-col cols="6" justify="center" align="center">
                  <h1>{{ resume.totalUses }}</h1>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col cols="3" align-content="stretch">
            <v-sheet color="#f5f6f9" class="px-3 BenefitsDetails-info-sheet" style="height:100%">
              <v-row justify="center" align="center" style="height:inherit">
                <v-col cols="6" justify="center" align="start">
                  <strong class="primary--text">
                    {{ $t('modules.discountCoupons.details.studentsWithCoupons.resume.maxBenefitsStudents') }}
                  </strong><br>
                </v-col>
                <v-col cols="6" justify="center" align="center">
                  <h1>{{ resume.maxUsers }}</h1>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-data-table v-model="studentsWithCoupons.selected" :items="studentsWithCoupons.items"
              :headers="studentsWithCoupons.headers" :options="studentsWithCoupons.pagination"
              :server-items-length="studentsWithCoupons.serverItemsLength" hide-default-footer
              @pagination="studentsWithCoupons.pagination = $event" show-select item-key="identification"
              @update:sort-by="studentsWithCoupons.sort.by = $event"
              @update:sort-desc="studentsWithCoupons.sort.desc = $event"
              class="custom-table">
              <template #top>
                <v-row>
                  <v-col cols="4">
                    <v-text-field v-model="studentsWithCoupons.search" prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('actions.search')" outlined clearable class="superTable__search" />
                  </v-col>
                  <v-col offset="4" cols="4" align="right" v-if="canAssign && manualAssignation">
                    <v-btn large rounded color="primary" @click="tmpDrawer.open = true" :disabled="!(hasAvailability && discountCoupon?.manualAssignation && discountCoupon?.status && addStudent)">
                      {{ $t('modules.discountCoupons.details.studentsWithCoupons.actions.addStudents') }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div v-if="studentsWithZeroCoupons && studentsWithCoupons.selected.length" class="superTable__bulkActions py-2"
                      :class="studentsWithCoupons.selected.length ? 'show' : 'hide'">
                      <v-divider />
                      <div class="py-3">
                        <span v-if="canAssign" @click="bulkDeletePopUp"
                          class="caption mx-4 cursor-pointer hover-7-inverted">
                          <v-icon size="22" class="mr-2">mdi-delete</v-icon>
                          {{ $t('modules.discountCoupons.details.studentsWithCoupons.actions.deleteStudents') }}
                        </span>
                      </div>
                      <v-divider />
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template #header.data-table-select="{ on, props }">
                <v-simple-checkbox color="primary" v-bind="props" v-on="on" class="superTable__table__item__checkbox" />
              </template>
              <template #item.data-table-select="{ isSelected, select }">
                <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"
                  class="superTable__table__item__checkbox" />
              </template>
              <template #footer="{ props: { options, pagination } }">
                <v-row no-gutters align="center">
                  <v-col cols="3" md="3">
                    <span class="caption d-inline-block">
                      {{ `${pagination.pageStart + 1 }-${ pagination.pageStop} de ${pagination.itemsLength}` }}
                    </span>
                    <v-select v-model="options.itemsPerPage" :items="[20, 50, 100, 200]" outlined
                      class="superTable__paginationSelect d-inline-block ml-4" />
                  </v-col>
                  <v-col cols="6" md="6" class="d-flex align-center">
                    <v-pagination v-model="options.page" :length="pagination.pageCount" circle
                      style="width: calc(100% - 12px);" class="superTable__pagination" />
                  </v-col>
                  <v-col cols="3" class="d-flex flex-column align-end">
                    <v-text-field :value="options.page"
                      @change="(/^[1-9][0-9]*/.test($event) && Number($event) <= options.pageCount && Number($event) > 0) && (studentsWithCoupons.pagination.page = Number($event))"
                      outlined class="superTable__paginationInput d-inline-block mr-4" />
                    <span class="caption d-inline-block">
                      {{ $t('modules.discountCoupons.table.search.gotopage') }}
                    </span>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <TemporaryRightDrawer v-if="canAssign && openedDrawer" @tmpDrawerOpen="onCloseDrawer" :open="tmpDrawer.open"
          :title="tmpDrawer.title" :description="tmpDrawer?.description">
          <v-container fluid>
            <v-row>
              <v-col sm="12">
                <v-card outlined class="py-6 px-6">
                  <v-data-table v-model="students.selected" :items="students.items" :headers="students.headers"
                    :options="students.pagination" :server-items-length="students.serverItemsLength" hide-default-footer
                    @pagination="students.pagination = $event" show-select item-key="identification"
                    @update:sort-by="students.sort.by = $event"
                    @update:sort-desc="students.sort.desc = $event"
                    class="custom-table">
                    <template #top>
                      <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                          <h3>{{ $t('modules.discountCoupons.details.drawer.students.title') }}</h3>
                          <p>{{ $t('modules.discountCoupons.details.drawer.students.description') }}</p>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="students.search" prepend-inner-icon="mdi-magnify"
                            :placeholder="$t('actions.search')" outlined clearable class="superTable__search" />
                        </v-col>
                      </v-row>
                    </template>
                    <template #header.data-table-select="{ on, props }">
                      <v-simple-checkbox color="primary" v-bind="props" v-on="on"
                        class="superTable__table__item__checkbox" />
                    </template>
                    <template #item.data-table-select="{ isSelected, select }">
                      <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"
                        class="superTable__table__item__checkbox" />
                    </template>
                    <template #footer="{ props: { options, pagination } }">
                      <v-row>
                        <v-col cols="3" md="2" class="d-flex flex-column align-center">
                          <span class="caption d-inline-block">
                            {{ `${pagination.pageStart + 1 }-${ pagination.pageStop} de ${pagination.itemsLength}` }}
                          </span>
                          <v-select v-model="options.itemsPerPage" :items="[20, 50, 100, 200]" outlined
                            class="superTable__paginationSelect d-inline-block" />

                        </v-col>
                        <v-col cols="7" md="8" class="d-flex align-center">
                          <v-pagination v-model="options.page" :length="pagination.pageCount" circle
                            style="width: calc(100% - 12px);" class="superTable__pagination" />
                        </v-col>
                        <v-col cols="2" class="d-flex flex-column align-center">
                          <v-text-field :value="options.page"
                            @change="(/^[1-9][0-9]*/.test($event) && Number($event) <= options.pageCount && Number($event) > 0) && (students.pagination.page = Number($event))"
                            outlined class="superTable__paginationInput d-inline-block" />
                          <span class="caption d-inline-block">
                            {{ $t('modules.discountCoupons.table.search.gotopage') }}
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col sm="12" class="pb-8 d-flex justify-contentn-end justify-end">
                <Button white :text="$t('actions.cancel')" @clicked="onCloseDrawer" class="mr-6" />
                <Button :text="$t('actions.add')" @clicked="assignedStudents" @end="students.resetSubmit()"
                  :loading="students.submit.loading" :success="students.submit.success" :error="students.submit.error"
                  :successText="$t('actions.added')" :errorText="'Error'" :disabled="!students.selected.length" />
              </v-col>
            </v-row>
          </v-container>
        </TemporaryRightDrawer>
      </v-container>
    </v-container>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import TemporaryRightDrawer from '@/components/TemporaryRightDrawer/TemporaryRightDrawer'
import Button from '@/components/Button/Button';
import _ from 'lodash'

import { $discountCoupons, $studentsCoupon, $products } from '../Services';

export default {
  name: 'DiscountCouponsDetails',
  components: {
    Breadcrumbs,
    TemporaryRightDrawer,
    Button
  },
  data() {
    return {
      title: '',
      discountCoupon: {},
      products: [],
      students:{
        headers: [
          { text: this.$t('modules.discountCoupons.details.drawer.students.table.identification'), value: 'identification'},
          { text: this.$t('modules.discountCoupons.details.drawer.students.table.name'), value: 'fullname' },
        ],
        serverItemsLength: -1,
        search: '',
        pagination:{
          page: 1,
          pageCount: 1,
          itemsPerPage: 20
        },
        sort:{
          by: 'identification',
          desc: true
        },
        selected:[],
        items: [],
        submit:{
          loading: false,
          success: false,
          error: false
        },
        resetSubmit(){
          this.submit = {
            loading: false,
            success: false,
            error: false
          }
        }
      },
      studentsWithCoupons: {
        headers: [
          { text: this.$t('modules.discountCoupons.details.drawer.students.table.identification'), value: 'identification'},
          { text: this.$t('modules.discountCoupons.details.drawer.students.table.name'), value: 'fullname'},
          { text: this.$t('modules.discountCoupons.details.drawer.students.table.careerDescription'), value: 'careerDescription', sortable: false },
          {text: this.$t('modules.discountCoupons.details.drawer.students.table.usescouponUsesCount'), value:'couponUsesCount', sortable: false }
        ],
        serverItemsLength: -1,
        search: '',
        pagination:{
          page: 1,
          pageCount: 1,
          itemsPerPage: 20
        },
        sort:{
          by: 'identification',
          desc: true
        },
        selected:[],
        items: [],
      },
      manualAssignation:false,
      hasAvailability: true,
      openedDrawer: true,
      tmpDrawer: {
        open: false,
        title: this.$t('modules.discountCoupons.details.drawer.title'),
        description: this.$t('modules.discountCoupons.details.drawer.subtitle')
      },
    }
  },
  computed: {
    studentsWithZeroCoupons() {
      return this.studentsWithCoupons.selected.every(student => student.couponUsesCount === 0);
    },
    addStudent(){
      return this.discountCoupon.maxUsers !== this.studentsWithCoupons.serverItemsLength
    },
    canUpdate() {
      return this.$permissions.portaladministrativo.prices.discountCoupons.UPDATE
    },
    canAssign() {
      return this.$permissions.portaladministrativo.prices.discountCoupons.ASSIGN
    },
    resume(){
      const resume = {
        maxUsagesPerUser:'-',
        minPayment:'-',
        maxDiscount:'-',
        discount: '',
        dateFrom:'',
        dateTo:'-',
        totalStudents: 0,
        maxUsers: '-',
        totalUses:0,
        productType: '-'
      }
      if(this.discountCoupon.maxUsagesPerUser){
        resume.maxUsagesPerUser = `${this.discountCoupon.maxUsagesPerUser}`
      }
      if(this.discountCoupon.totalUsages){
        resume.totalUses = `${this.discountCoupon.totalUsages}`
      }
      if(this.discountCoupon.minPayment){
        resume.minPayment = Number(this.discountCoupon.minPayment)
      }
      if(this.discountCoupon.maxDiscount){
        resume.maxDiscount = Number(this.discountCoupon.maxDiscount)
      }
      if(this.discountCoupon.dateFrom){
        resume.dateFrom = `${this.discountCoupon.dateFrom}`
      }
      if(this.discountCoupon.dateTo){
        resume.dateTo = `${this.discountCoupon.dateTo}`
      }
      if(this.discountCoupon.percentageDiscount && Number(this.discountCoupon.percentageDiscount) > 0){
        resume.discount =  `${parseFloat(this.discountCoupon.percentageDiscount).toFixed(2)}%`
      }
      if(this.discountCoupon.ammountDiscount && Number(this.discountCoupon.ammountDiscount) > 0){
        resume.discount = this.$options.filters.formatCurrency(Number(this.discountCoupon.ammountDiscount))
      }
      if(this.discountCoupon.billingProductId){
        const product = this.products.find(p => p.id === this.discountCoupon.billingProductId);
        resume.productType = product ? product.name : '-';
      }
      if(this.discountCoupon.maxUsers){
        if(this.studentsWithCoupons.serverItemsLength > 0){
          const maxUser = this.discountCoupon.maxUsers - this.studentsWithCoupons.serverItemsLength
          resume.maxUsers = maxUser > 0 ? maxUser : 0
        }else{
          resume.maxUsers = this.discountCoupon.maxUsers
        }
      }
      if(this.studentsWithCoupons.serverItemsLength > 0){
        resume.totalStudents = this.studentsWithCoupons.serverItemsLength
      }
      return resume
    }
  },
  filters: {
    formatCurrency(value) {
      if(!value || isNaN(value)) return '-'
      return `$${value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  },
  methods: {
    async getDiscountCoupons() {
      try {
        const { data } = await $discountCoupons.findById(this.$route.params.id)
        this.discountCoupon = data
        this.manualAssignation = this.discountCoupon.manualAssignation
      } catch (error) {
        this.discountCoupon = null
      }
    },
    async getProducts() {
      try {
        const { data } = await $products.find();
        this.products = data.content;
      } catch (error) {
        this.products = [];
      }
    },
    async getStudents(){
      try {
        this.students.selected = []

        const params = {
          page: this.students.pagination.page - 1,
          length: this.students.pagination.itemsPerPage,
          orderBy: this.students.sort.by === 'fullname'? 'name':this.students.sort.by,
          orientation: this.students.sort.desc? 'desc':'asc',
          search: this.students.search || '',
          id: this.$route.params.id
        }
        const { data } = await $studentsCoupon.find(null, null, { params })
        if(!data.content.length) throw null
        this.students.items = data.content
          .map(student=>({
            ...student,
            fullname: `${student.lastname} `.concat(student.name)
          }))

        this.students.serverItemsLength = data.totalElements
        this.students.pagination.pageCount = data.totalPages
      } catch {
        //empty
      }
    },
    async getStudentsWithCoupons(){
      try {
        this.studentsWithCoupons.selected = []
        const params = {
          page: this.studentsWithCoupons.pagination.page - 1,
          length: this.studentsWithCoupons.pagination.itemsPerPage,
          orderBy: this.studentsWithCoupons.sort.by === 'fullname'? 'name':this.studentsWithCoupons.sort.by,
          orientation: this.studentsWithCoupons.sort.desc? 'desc':'asc',
          search: this.studentsWithCoupons.search || '',
          id: this.$route.params.id
        }
        const { data } = await $discountCoupons.find(`students`, null, { params })

        this.studentsWithCoupons.items = data.content
          .map(student=>({
            ...student,
            fullname: `${student.lastName} `.concat(student.name)
          }))

        this.studentsWithCoupons.serverItemsLength = data.totalElements
        this.studentsWithCoupons.pagination.pageCount = data.totalPages
      } catch {
        //empty
      }
    },
    async assignedStudents(){
      try {

        const students = this.students.selected.map(student=> student.id)
        const hasAvailability = await this.hasAvailabilityStudents(students.length)
        if(!hasAvailability){
          throw { title: this.$t('modules.discountCoupons.details.studentsWithCoupons.popup.assigned.errors.maxUsers')}
        }
        this.students.submit.loading = true
        await $discountCoupons.create(null, { params:{ students: students.join(',') }},`assign-student/${this.$route.params.id}`)
        this.students.submit.success = true
        this.getStudentsWithCoupons()
        this.getDiscountCoupons()
        this.onCloseDrawer()
        this.hasAvailability = await this.hasAvailabilityStudents()
      } catch (error) {
        this.students.submit.error = true
        this.$store.dispatch('commons/openPopUp', {
          title: error&&error.title || this.$t('modules.discountCoupons.details.studentsWithCoupons.popup.assigned.errors.general'),
          content: [{ value: this.discountCoupon.description }],
          actionPrimary: { text: this.$t('actions.accept'), callback: () => this.onCloseDrawer() },
          icon: { color: 'error', name: 'mdi-delete' },
          color: 'primary'
        })
      }finally{
        this.students.submit.success = false
      }
    },
    async hasAvailabilityStudents(length=1){
      const idCoupon= this.$route.params.id
      const { data } = await $discountCoupons.find(`assign-student/check`,null, { params:{idCoupon, amountStudents: length }})
      return data
    },
    resetPageStudents(){
      this.students.serverItemsLength = -1
      this.students.pagination = {
        ...this.students.pagination,
        page: 1,
        pageCount: 1,
      }
    },
    resetPageStudentsWithCoupons(){
      this.studentsWithCoupons.serverItemsLength = -1
      this.studentsWithCoupons.pagination = {
        ...this.studentsWithCoupons.pagination,
        page: 1,
        pageCount: 1,
      }
    },
    onCloseDrawer() {
      this.tmpDrawer.open = false
      this.students.selected = []
      this.students.resetSubmit()
    },
    //TODO: DELETE
    deleteDiscountPopUp (id) {
      this.$store.dispatch('commons/openPopUp', {
        title: this.$t('modules.discountCoupons.table.messages.popup.title'),
        content: [],
        actionPrimary: { text: this.$t('actions.accept'), callback: () => this.deleteDiscount(id) },
        actionSecondary: { text: this.$t('actions.cancel'), callback () { } },
        icon: { color: 'error', name: 'mdi-delete' },
        color: 'primary',
      })
    },
    async deleteDiscount (id) {
      try {
        await $discountCoupons.delete(id);
        this.$router.replace('/coupons')
      } catch (error) {
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error',
          content: [{ value: this.$t('modules.discountCoupons.details.studentsWithCoupons.popup.delete.title') }],
          actionPrimary: { text: this.$t('actions.cancel'), callback () { } },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary',
        });
        throw error
      }
    },
    bulkDeletePopUp() {
      this.$store.dispatch('commons/openPopUp', {
        title: this.$t('modules.discountCoupons.details.studentsWithCoupons.popup.delete.title'),
        content: this.studentsWithCoupons.selected.map(student => ({ value: `${student.id} - ${student.fullname}` })),
        actionPrimary: { text: this.$t('actions.accept'), callback: async() => {
          await this.bulkDelete()
          this.getDiscountCoupons()
          this.resetPageStudentsWithCoupons()
        }},
        actionSecondary: { text: this.$t('actions.cancel'), callback:()=> this.studentsWithCoupons.selected = []  },
        icon: { color: 'error', name: 'mdi-delete' },
        color: 'primary',
      })
    },
    async bulkDelete() {
      try {
        const students = this.studentsWithCoupons.selected
          .map(student=> student.studentId)
          .join(',')
        const { id: idCoupon } = this.$route.params
        await $discountCoupons.delete(null, { params:{idCoupon,students}}, `assign-student`);
        this.getStudentsWithCoupons()
        this.hasAvailability = await this.hasAvailabilityStudents()
      }
      catch {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.discountCoupons.details.studentsWithCoupons.popup.delete.errors.general'),
          content: null,
          actionPrimary: { text: this.$t('actions.accept'), callback() { } },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary'
        })
      }
    }
  },
  created(){
    this.getStudents = _.debounce(this.getStudents, 500)
    this.getStudentsWithCoupons = _.debounce(this.getStudentsWithCoupons, 500)
    Promise.all([
      this.getDiscountCoupons(),
      this.getProducts()
    ])
  },
  async mounted() {
    this.getDiscountCoupons()
    this.getStudents()
    this.getStudentsWithCoupons()
    this.hasAvailability = await this.hasAvailabilityStudents()
  },
  watch: {
    /* eslint-disable object-shorthand */
    ['students.search'](){
      this.resetPageStudents()
      this.getStudents()
    },
    ['students.pagination.page'](){
      this.getStudents()
    },
    ['students.pagination.itemsPerPage'](){
      this.resetPageStudents()
      this.getStudents()
    },
    ['students.sort']:{
      handler(){
        this.resetPageStudents()
        this.getStudents()
      },
      deep:true
    },
    ['studentsWithCoupons.search'](){
      this.resetPageStudentsWithCoupons()
      this.getStudentsWithCoupons()
    },
    'studentsWithCoupons.pagination.page'(){
      this.getStudentsWithCoupons()
    },
    ['studentsWithCoupons.pagination.itemsPerPage'](){
      this.resetPageStudentsWithCoupons()
      this.getStudentsWithCoupons()
    },
    ['studentsWithCoupons.sort']:{
      handler(){
        this.resetPageStudentsWithCoupons()
        this.getStudentsWithCoupons()
      },
      deep:true
    }
    /* eslint-disable object-shorthand */
  }
}
</script>

<style lang="sass" scoped>
</style>
